import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import { useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
var serialize = require('serialize-javascript');
var moment = require('moment')

function Circumstances (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);

    const prevLocation = {
        pathname: '../job',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }
    const next = () =>{
        let nextLocation = {}
        if (Field48Witness === "yes") {
            nextLocation = {
                pathname: '../witnesses',
                state: {d: d}
            }
        }else {
            nextLocation = {
                pathname: '../consequences',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const [stored, setStored] =  useState("")
    const [Age, setAge]= useState("")
    const [JobStudent, setJobStudent]= useState({})


    // set control value and name to classic inputs using the custom Hook useInput
    const {value: Field2and3HourAccident, bind: bindField2and3HourAccident, reset: setField2and3HourAccident } = useInput('');
    const {value: Field4LocationAccident, bind: bindField4LocationAccident, reset: setField4LocationAccident } = useInput('');
    const {value: Field5HowOther, bind: bindField5HowOther, reset: setField5HowOther } = useInput('');
    const {value: Field5HowCirculation, bind: bindField5HowCirculation, reset: setField5HowCirculation } = useInput('');
    const {value: Field5HowStepType, bind: bindField5HowStepType, reset: setField5HowStepType } = useInput('');
    const {value: Field5HowStepBrand, bind: bindField5HowStepBrand, reset: setField5HowStepBrand } = useInput('');
    const {value: Field5HowVeloElecType, bind: bindField5HowVeloElecType, reset: setField5HowVeloElecType } = useInput('');
    const {value: Field5HowVeloElecBrand, bind: bindField5HowVeloElecBrand, reset: setField5HowVeloElecBrand } = useInput('');

    const {value: Field4701Insurer, bind: bindField4701Insurer, reset: setField4701Insurer} = useInput('')
    const {value: Field4702AddressStreet, bind: bindField4702AddressStreet, reset: setField4702AddressStreet} = useInput('')
    const {value: Field4702AddressStreetNumber, bind: bindField4702AddressStreetNumber, reset: setField4702AddressStreetNumber} = useInput('')
    const {value: Field4702AddressStreetBox, bind: bindField4702AddressStreetBox, reset: setField4702AddressStreetBox} = useInput('')
    const {value: Field4702AddressZip, bind: bindField4702AddressZip, reset: setField4702AddressZip} = useInput('')
    const {value: Field4702AddressTown, bind: bindField4702AddressTown, reset: setField4702AddressTown} = useInput('')

    // radio input custom handleChange
    const [Field5How, setField5How] = useState("");
    const handleChangeField5How = (e) => {
        let value = e.target.value
        setField5How(value);
    }
    const [Field5HowVelo, setField5HowVelo] = useState("");
    const handleChangeField5HowVelo = (e) => {
        let value = e.target.value
        setField5HowVelo(value);
    }
    const [Field47TypeAccident, setField47TypeAccident] = useState("");
    const handleChangeField47TypeAccident = (e) => {
        let value = e.target.value
        setField47TypeAccident(value);
    }
    const [Field48Witness, setField48Witness] = useState("");
    const handleChangeField48Witness = (e) => {
        let value = e.target.value
        setField48Witness(value);
    }

    const [Field2and3DateAccidentError, setField2and3DateAccidentError]= useState("")
    const [Field2and3DateAccidentEarlierError, setField2and3DateAccidentEarlierError]= useState("")
    const [Field2and3DateAccidentFormatError, setField2and3DateAccidentFormatError]= useState("")
    const [Field2and3DateAccident, setField2and3DateAccident] = useState("");


    const DateValidation = (e) => {
        setField2and3DateAccident(e.target.value)

            //console.log(date);
          //console.log(e.target.value)
            let dateDate = moment(e.target.value, "YYYY-MM-DD")
            let validDate = moment(dateDate, 'YYYY-MM-DD', true).isValid()
            //console.log(Field2and3DateAccident)
            if (validDate) {
                let pastDate = dateDate.isBefore(moment())
                setField2and3DateAccidentFormatError(false)
                if (!pastDate) {
                    setField2and3DateAccidentError(true)
                    setField2and3DateAccidentEarlierError(true)
                }else{
                    setField2and3DateAccidentEarlierError(false)
                    setField2and3DateAccidentError(false)
                    //console.log(date)

                }
            }

    }
    useEffect(() => {
        window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            //const dead = "true"
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            const storedAge = localStorage.getItem('Age')
            setAge(storedAge)
            setIsLoading(false);

            const JobStudent = JSON.parse(localStorage.getItem('jobStudent'))

            if (JobStudent){
                setJobStudent(true)
            }

            const circumstances = JSON.parse(localStorage.getItem('circumstances'))

            if (circumstances){
                setStored(true)
                setField2and3HourAccident(circumstances.Field2and3HourAccident)
                setField4LocationAccident(circumstances.Field4LocationAccident)
                setField5HowOther(circumstances.Field5HowOther)
                setField5HowCirculation(circumstances.Field5HowCirculation)
                setField5HowStepType(circumstances.Field5HowStepType)
                setField5HowStepBrand(circumstances.Field5HowStepBrand)
                setField5HowVeloElecType(circumstances.Field5HowVeloElecType)
                setField5HowVeloElecBrand(circumstances.Field5HowVeloElecBrand)
                setField4701Insurer(circumstances.Field4701Insurer)
                setField4702AddressStreet(circumstances.Field4702AddressStreet)
                setField4702AddressStreetNumber(circumstances.Field4702AddressStreetNumber)
                setField4702AddressStreetBox(circumstances.Field4702AddressStreetBox)
                setField4702AddressZip(circumstances.Field4702AddressZip)
                setField4702AddressTown(circumstances.Field4702AddressTown)
                setField5How(circumstances.Field5How)
                setField5HowVelo(circumstances.Field5HowVelo)
                setField47TypeAccident(circumstances.Field47TypeAccident)
                setField48Witness(circumstances.Field48Witness)
                setField2and3DateAccident(circumstances.Field2and3DateAccident)
            }
        };
        fetchData()
    }, []);
    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = Field4LocationAccident === "" ||
            Field47TypeAccident === "" ||
            Field48Witness === "" ||
            Field2and3DateAccident === "" ||
            Field5How === "" ||
            (Field5How === "velo" && Field5HowVelo === "") ||
            (Field5How === "autre" && Field5HowOther === "") ||
            (Field5How === "participantcirculation" && Field5HowCirculation === "" )

          //console.log(notValid)
            setNotValid(notValid)
        if (!notValid){
            let circumstances = {
                Field2and3HourAccident:Field2and3HourAccident,
                Field4LocationAccident:Field4LocationAccident,
                Field5HowOther:Field5HowOther,
                Field5HowCirculation:Field5HowCirculation,
                Field5HowStepType:Field5HowStepType,
                Field5HowStepBrand:Field5HowStepBrand,
                Field5HowVeloElecType:Field5HowVeloElecType,
                Field5HowVeloElecBrand:Field5HowVeloElecBrand,
                Field4701Insurer:Field4701Insurer,
                Field4702AddressStreet:Field4702AddressStreet,
                Field4702AddressStreetNumber:Field4702AddressStreetNumber,
                Field4702AddressStreetBox:Field4702AddressStreetBox,
                Field4702AddressZip:Field4702AddressZip,
                Field4702AddressTown:Field4702AddressTown,
                Field5How:Field5How,
                Field5HowVelo:Field5HowVelo,
                Field47TypeAccident:Field47TypeAccident,
                Field48Witness:Field48Witness,
                Field2and3DateAccident:Field2and3DateAccident,
            }
            //let stringInfo = JSON.stringify(circumstances)
            let stringInfo = serialize(circumstances, {isJSON: true});
            localStorage.setItem("circumstances" , stringInfo)
            //console.log(JSON.parse(stringInfo))
            next()
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={4}/>:<BreadCrumb n={5}/>}

                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("CIRCUMSTANCESTITLE"): i18n.t("CIRCUMSTANCESTITLE") }</h3>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">

                                    <FormGroup>
                                        <Label for="Field4LocationAccident">{  i18n.t('LOCATIONACCIDENT') } <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} className="form-control" {...bindField4LocationAccident} placeholder={i18n.t('PLACEHOLDERLOCATIONACCIDENT') } invalid={(NotValid && Field4LocationAccident === "") ? true : undefined}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <div className={(Field2and3DateAccidentError  || Field2and3DateAccidentEarlierError || Field2and3DateAccidentFormatError)? "form-group text-danger" : "form-group"}>
                                        <Label for="Field2and3DateAccident">{i18n.t("DATEACCIDENT")} <span className={"text-danger"}>*</span></Label>
                                        <Input onChange={DateValidation} type="date" value={Field2and3DateAccident} invalid={(NotValid && Field2and3DateAccidentError)}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        {Field2and3DateAccidentEarlierError && <p>{i18n.t("La date doit être dans le passé")}</p>}
                                        {Field2and3DateAccidentFormatError && <p>{i18n.t("La date n'est pas correctement encodée")} : {i18n.t("jj/mm/yyyy")} </p>}
                                    </div>
                                    <FormGroup>
                                        <Label for="Field2and3HourAccident">{  i18n.t('HOURACCIDENT') }</Label>
                                        <Input type="text" maxLength={500} className="form-control" {...bindField2and3HourAccident} placeholder={i18n.t("hhmm")}/>
                                    </FormGroup>
                                    <h4>{i18n.t("Type d’accident")}</h4>
                                    <FormGroup check>
                                        <Label for="Field5How" className={(NotValid && Field5How === "") ? "text-danger" : "text"}>{ d? i18n.t('Votre proche est décédé(e)') :  i18n.t('Vous avez été blessé')  }:  <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How"  value="conducteur"  onChange={handleChangeField5How} checked={Field5How === "conducteur"} />
                                                {  i18n.t('field5HowConducteur') }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How" value="passager"  onChange={handleChangeField5How} checked={Field5How === "passager"} />
                                                {  i18n.t('field5HowPassager') }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How" value="velo"  onChange={handleChangeField5How} checked={Field5How === "velo"} />
                                                {  i18n.t('field5HowVelo') }
                                            </Label>
                                        </div>
                                        {Field5How === "velo" &&
                                        <div className="formlevel02">
                                            <FormGroup check>
                                                <Label for="radio" className={(NotValid && Field5HowVelo === "") ? "text-danger" : "text"}>{ !!d ?  i18n.t('précisez') : i18n.t('label')  } <span className={"text-danger"}>*</span></Label>
                                                <div className="checkbox">
                                                    <Label>
                                                        <Input type="radio" name="Field5HowVelo" onChange={handleChangeField5HowVelo} value="veloNormal"  checked={Field5HowVelo === "veloNormal"} />
                                                        {  i18n.t('field5HowVeloNormal') }
                                                    </Label>
                                                </div>
                                                <div className="checkbox">
                                                    <Label>
                                                        <Input type="radio" name="Field5HowVelo" value="veloElec"  onChange={handleChangeField5HowVelo} checked={Field5HowVelo === "veloElec"} />
                                                        {  i18n.t('field5HowVeloElec') }
                                                    </Label>
                                                </div>
                                            </FormGroup>
                                            {Field5HowVelo === "veloElec" &&
                                            <div className={"formlevel02"}>
                                                <FormGroup>
                                                    <Input type="text" maxLength={500} {...bindField5HowVeloElecBrand}
                                                           placeholder={i18n.t("Marque")}
                                                           invalid={(NotValid && Field5HowVeloElecBrand === "true") ? true : undefined}/>
                                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Input type="text" maxLength={500} {...bindField5HowVeloElecType}
                                                           placeholder={i18n.t("Type")}
                                                           invalid={(NotValid && Field5HowVeloElecType === "true") ? true : undefined}/>
                                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                                </FormGroup>
                                            </div>
                                            }
                                        </div>}
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How" value="step"  onChange={handleChangeField5How} checked={Field5How === "step"} />
                                                {  i18n.t('field5HowStep') }
                                            </Label>
                                        </div>
                                        {Field5How === "step" &&
                                        <div className={'formlevel02'}>
                                            <FormGroup>
                                                <Input type="text" maxLength={500} {...bindField5HowStepBrand}
                                                       placeholder={i18n.t("Marque")}
                                                       invalid={(NotValid && Field5HowStepBrand === "true") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Input type="text" maxLength={500} {...bindField5HowStepType}
                                                       placeholder={i18n.t("Type")}
                                                       invalid={(NotValid && Field5HowStepType === "true") ? true : undefined}/>
                                                <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How" value="participantcirculation"  onChange={handleChangeField5How} checked={Field5How === "participantcirculation"} />
                                                {  i18n.t('field5HowParticipantcirculation') }
                                            </Label>
                                        </div>
                                        {Field5How === "participantcirculation" &&
                                        <FormGroup className={"formlevel02"}>
                                            <Label for="Field5HowCirculation">{  i18n.t('précisez') } <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className="form-control" {...bindField5HowCirculation} placeholder={i18n.t('précisez') } invalid={(NotValid && Field5HowCirculation === "") ? true : undefined}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field5How" value="autre"  onChange={handleChangeField5How} checked={Field5How === "autre"} />
                                                {  i18n.t('field5HowAutre') }
                                            </Label>
                                        </div>
                                        {Field5How === "autre" &&
                                        <FormGroup className={"formlevel02"}>
                                            <Label for="Field5HowOther">{  i18n.t('précisez') } <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className="form-control" {...bindField5HowOther} placeholder={i18n.t('précisez') } invalid={(NotValid && Field5HowOther === "") ? true : undefined}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                        }
                                    </FormGroup>
                                    <FormGroup check>
                                        <Label for="radio" className={(NotValid && Field47TypeAccident === "") ? "text-danger" : "text"}>{ d? i18n.t('Votre proche est décédé(e)') :  i18n.t('Vous avez été blessé')  }: <span className={"text-danger"}>*</span></Label>
                                        { Age > 15 &&
                                        <div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field47TypeAccident" onChange={handleChangeField47TypeAccident} value="chemintravail"  checked={Field47TypeAccident === "chemintravail"} />
                                                    {  i18n.t('chemintravail') } ?
                                                </Label>
                                            </div>
                                            {Field47TypeAccident === "chemintravail" &&
                                            <div className="formlevel02">
                                                {Field4701Insurer === "" &&
                                                <Alert color={'warning'}>
                                                    <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                                    <strong>{i18n.t("Information")}</strong>
                                                    <hr className="message-inner-separator"/>
                                                    <p>{i18n.t("field47014702Warning")}</p>
                                                </Alert>
                                                }
                                                <FormGroup>
                                                    <Label for="Field4701Insurer">{d? i18n.t("field4701Insurer") : i18n.t("field4701Insurer")}</Label>
                                                    <Input type="text" maxLength={500} {...bindField4701Insurer} placeholder={d? i18n.t("PLACEHOLDERNAMEDATADEATH") : i18n.t("PLACEHOLDERNAMEDATA")}/>
                                                    <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </FormGroup>
                                                <div>
                                                    <Label for="Field4702Address">{i18n.t("ADDRESSDATA")}</Label>
                                                    <FormGroup className="row py-0">
                                                        <Label for="Field4702AddressStreet" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreet === "")? true : undefined}>{i18n.t("field4702AddressStreet")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressStreet} placeholder={i18n.t("field4702AddressStreet")} />

                                                    </FormGroup>
                                                    <FormGroup className="row py-0">
                                                        <Label for="Field4702AddressStreetNumber" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreetNumber === "")? true : undefined}>{i18n.t("field4702AddressStreetNumber")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField4702AddressStreetNumber} placeholder={i18n.t("field4702AddressStreetNumber")} />

                                                        <Label  for="Field4702AddressStreetBox" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreetBox === "")? true : undefined}>{i18n.t("field4702AddressStreetBox")}</Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField4702AddressStreetBox} placeholder={i18n.t("field4702AddressStreetBox")} />

                                                    </FormGroup>
                                                    <FormGroup className="row  py-0">
                                                        <Label for="Field4702AddressZip" className={"col-sm-2"}  invalid={(NotValid && Field4702AddressZip === "")? true : undefined}>{i18n.t("field4702AddressZip")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressZip} placeholder={i18n.t("field4702AddressZip")}/>

                                                    </FormGroup>
                                                    <FormGroup className="row  py-0">
                                                        <Label for="Field4702AddressTown" className={"col-sm-2"} invalid={(NotValid && Field4702AddressTown === "")? true : undefined}>{i18n.t("field4702AddressTown")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressTown} placeholder={i18n.t("field4702AddressTown")}/>
                                                    </FormGroup>
                                                    
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        }
                                        { !!JobStudent  &&
                                        <div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field47TypeAccident" value="cheminecole"  onChange={handleChangeField47TypeAccident} checked={Field47TypeAccident === "cheminecole"} />
                                                    {  i18n.t('cheminecole') } ?
                                                </Label>
                                            </div>
                                            {Field47TypeAccident=== "cheminecole" &&
                                            <div className="formlevel02">
                                                {Field4701Insurer === "" &&
                                                <Alert color={'warning'}>
                                                    <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                                    <strong>{i18n.t("Information")}</strong>
                                                    <hr className="message-inner-separator"/>
                                                    <p>{i18n.t("field47014702Warning")}</p>
                                                </Alert>
                                                }
                                                <FormGroup>
                                                    <Label for="Field4701Insurer">{d? i18n.t("field4703Insurer") : i18n.t("field4703Insurer")}</Label>
                                                    <Input type="text" maxLength={500} {...bindField4701Insurer} placeholder={d? i18n.t("PLACEHOLDERNAMEDATADEATH") : i18n.t("PLACEHOLDERNAMEDATA")}/>
                                                    <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </FormGroup>
                                                <div>
                                                    <Label for="Field4702Address">{i18n.t("ADDRESSDATA")}</Label>
                                                    <FormGroup className="row py-0">
                                                        <Label for="Field4702AddressStreet" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreet === "")? true : undefined}>{i18n.t("field4702AddressStreet")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressStreet} placeholder={i18n.t("field4702AddressStreet")} />

                                                    </FormGroup>
                                                    <FormGroup className="row py-0">
                                                        <Label for="Field4702AddressStreetNumber" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreetNumber === "")? true : undefined}>{i18n.t("field4702AddressStreetNumber")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField4702AddressStreetNumber} placeholder={i18n.t("field4702AddressStreetNumber")} />

                                                        <Label  for="Field4702AddressStreetBox" className={"col-sm-2"} invalid={(NotValid && Field4702AddressStreetBox === "")? true : undefined}>{i18n.t("field4702AddressStreetBox")}</Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField4702AddressStreetBox} placeholder={i18n.t("field4702AddressStreetBox")} />

                                                    </FormGroup>
                                                    <FormGroup className="row  py-0">
                                                        <Label for="Field4702AddressZip" className={"col-sm-2"}  invalid={(NotValid && Field4702AddressZip === "")? true : undefined}>{i18n.t("field4702AddressZip")} </Label>

                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressZip} placeholder={i18n.t("field4702AddressZip")}/>

                                                    </FormGroup>
                                                    <FormGroup className="row  py-0">
                                                        <Label for="Field4702AddressTown" className={"col-sm-2"} invalid={(NotValid && Field4702AddressTown === "")? true : undefined}>{i18n.t("field4702AddressTown")} </Label>
                                                        <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField4702AddressTown} placeholder={i18n.t("field4702AddressTown")}/>
                                                    </FormGroup>
                                                    
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field47TypeAccident" value="vieprivee"  onChange={handleChangeField47TypeAccident} checked={Field47TypeAccident === "vieprivee"} />
                                                {d?  i18n.t('viepriveeDeath'):i18n.t('vieprivee') } ?
                                            </Label>
                                        </div>
                                    </FormGroup>
                                    <h4>{i18n.t('Les témoins')}</h4>
                                    <FormGroup check>
                                        <Label for="radio" className={(NotValid && Field48Witness === "") ? "text-danger" : "text"}>{  i18n.t('Y a-t-il eu des témoins de l’accident ?')  } <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field48Witness" onChange={handleChangeField48Witness} value="no"  checked={Field48Witness === "no"} />
                                                {  i18n.t('NO') }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field48Witness" value="yes"  onChange={handleChangeField48Witness} checked={Field48Witness === "yes"} />
                                                {  i18n.t('YES') }
                                            </Label>
                                        </div>
                                    </FormGroup>


                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }</button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }</button>
                                    </div>
                                    }
                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Circumstances

